/* eslint-disable no-unused-vars */
export enum MediaQueries {
  SmUp = '(min-width: 640px)',
  MdUp = '(min-width: 768px)',
  LgUp = '(min-width: 1024px)',
  XlUp = '(min-width: 1280px)',
  TwoXlUp = '(min-width: 1536px)',

  SmDown = '(max-width: 640px)',
  MdDown = '(max-width: 768px)',
  LgDown = '(max-width: 1024px)',
  XlDown = '(max-width: 1280px)',
  TwoXlDown = '(max-width: 1536px)'
}
